import { atom } from "jotai";

export const viewAtom = atom("");

export const timeAtom = atom(0);
